import { render } from "./FKBreadCrumbItem.vue?vue&type=template&id=f8b5bd32&ts=true"
import script from "./FKBreadCrumbItem.vue?vue&type=script&lang=ts"
export * from "./FKBreadCrumbItem.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Widgets/BreadCrumb/FKBreadCrumbItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f8b5bd32"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f8b5bd32', __exports__)) {
    api.reload('f8b5bd32', __exports__)
  }
  
  module.hot.accept("./FKBreadCrumbItem.vue?vue&type=template&id=f8b5bd32&ts=true", () => {
    api.rerender('f8b5bd32', render)
  })

}


export default __exports__